/** The bookings diary: appointments taken on the storefront. Conventions: see `common.ts`. */
const bookings: Record<string, string> = {
  title: 'Bookings',
  in_view: '{total} in this view',
  loading: 'Loading your diary…',
  timezone: 'All times in {zone}',
  'own.title': 'My appointments',
  'own.with': 'Appointments booked with {name}',
  'own.unlinked_title': 'Your login is not linked to your profile yet',
  'own.unlinked': 'Ask the owner to link your login to you on Our team. Your appointments will show here once they do.',
  'schedule.title': 'My schedule',
  'schedule.intro': 'The days and times customers can book you. Changes show on the booking calendar straight away.',
  'schedule.loading': 'Loading your schedule…',
  'schedule.load_error': 'Your schedule could not be loaded. Please try again.',
  'schedule.follow': 'Same as the booking calendar',
  'schedule.follow_hint': 'You can be booked whenever the business takes bookings.',
  'schedule.custom': 'My own hours',
  'schedule.custom_hint': 'Choose the days and times you work. A day you leave closed is a day off.',
  'schedule.all_closed': 'Open at least one day, or use the booking calendar\'s hours.',
  'schedule.save': 'Save my hours',
  'schedule.saving': 'Saving…',
  'schedule.saved': 'Your hours are saved.',
  'schedule.save_error': 'Your hours could not be saved. Please try again.',

  'tabs.aria_label': 'Booking views',
  'tabs.upcoming': 'Upcoming',
  'tabs.today': 'Today',
  'tabs.pending': 'Needs a reply',
  'tabs.past': 'Past',

  'actions.no_show': 'No-show',

  'outcome.CONFIRMED': 'Appointment confirmed.',
  'outcome.COMPLETED': 'Appointment marked as done.',
  'outcome.NO_SHOW': 'Appointment marked as a no-show.',
  'outcome.CANCELLED': 'Appointment cancelled.',
  'outcome.updated': 'Appointment updated.',

  'confirm_action.back': 'Go back',
  'confirm_action.CONFIRMED.title': 'Confirm this appointment?',
  'confirm_action.CONFIRMED.message': 'Confirm {name}’s {service} on {when}? The customer is emailed.',
  'confirm_action.CONFIRMED.button': 'Confirm appointment',
  'confirm_action.COMPLETED.title': 'Mark as done?',
  'confirm_action.COMPLETED.message': 'Mark {name}’s {service} on {when} as done?',
  'confirm_action.COMPLETED.button': 'Mark as done',
  'confirm_action.NO_SHOW.title': 'Mark as a no-show?',
  'confirm_action.NO_SHOW.message': 'Mark {name} as a no-show for {service} on {when}? It stays on their visit history.',
  'confirm_action.NO_SHOW.button': 'Mark as no-show',
  'confirm_action.CANCELLED.title': 'Cancel this appointment?',
  'confirm_action.CANCELLED.message': 'Cancel {name}’s {service} on {when}? The customer is emailed and the time is opened for booking again. This cannot be undone.',
  'confirm_action.CANCELLED.button': 'Cancel appointment',

  'errors.update_failed': 'Could not update that appointment.',

  search_label: 'Search bookings',
  search_placeholder: 'Name, email, phone or service…',

  'empty.search_title': 'Nothing matches that search',
  'empty.search_description': 'Try a name, an email address, a phone number, or the name of a service.',
  'empty.title': 'No bookings in this view',
  'empty.description':
    'Appointments booked on your storefront appear here. Add the “Bookings & appointments” section to a page under Theme to start taking them.',

  'columns.contact': 'Contact',
  'columns.notes': 'Note',

  'select_row': 'Select {name}',

  'filters.dates': 'Appointment date',
  'filters.any_service': 'Any service',

  'sort.soonest': 'Soonest first',
  'sort.latest': 'Latest first',
  'sort.newest': 'Recently booked',

  'view.list': 'List view',
  'view.agenda': 'Day by day',
  'agenda.count_one': '{count} appointment',
  'agenda.count_other': '{count} appointments',

  'kpi.pending_hint': 'Somebody is waiting on you',
  'kpi.no_show_hint': 'In the slice on screen',

  'detail.contact': 'Get in touch',
  'detail.ends': 'Ends',
  'detail.booked_on': 'Booked on',
  'detail.note': 'What they wrote',

  'bulk.emails_customers': 'This emails the customer, as it does one at a time',
  'bulk.confirm_title': 'Confirm appointments',
  'bulk.confirm_message_one': 'Confirm {count} appointment? The customer is emailed.',
  'bulk.confirm_message_other': 'Confirm {count} appointments? Each customer is emailed.',
  'bulk.cancel_title': 'Cancel appointments',
  'bulk.cancel_message_one':
    'Cancel {count} appointment? The time goes back on sale and the customer is emailed. There is no undo.',
  'bulk.cancel_message_other':
    'Cancel {count} appointments? Their times go back on sale and each customer is emailed. There is no undo.',
  'bulk.done_one': '{count} appointment updated.',
  'bulk.done_other': '{count} appointments updated.',
  'bulk.partial': '{done} updated, {failed} could not be.',
  'bulk.partial_hint': 'Somebody else most likely dealt with them first.',

  'columns.when': 'When',
  'columns.service': 'Service',
  'columns.customer': 'Customer',
  'columns.status': 'Status',

  // Who and where, for sections that book people (Our team) or services held
  // online or at the customer's address.
  'columns.person': 'With',
  'filters.any_person': 'Anyone',
  'detail.with': 'With',
  'detail.where': 'Where',
  // Answers to the merchant's own booking questions, in the detail dialog.
  'detail.answers': 'Their answers',
  'detail.answer_yes': 'Yes',
  'detail.answer_no': 'No',
  'location.place': 'At your place',
  'location.online': 'Online',
  'location.address': "At the customer's address",
  'location.no_address': 'address not given',

  duration: '{minutes} min',

  'status.PENDING': 'PENDING',
  'status.CONFIRMED': 'CONFIRMED',
  'status.CANCELLED': 'CANCELLED',
  'status.COMPLETED': 'COMPLETED',
  'status.NO_SHOW': 'NO SHOW',

  'customer_filter.named': 'Customer: {name}',
  'customer_filter.one': 'One customer\'s appointments',
  'customer_filter.clear': 'Show every customer',
  'status.AWAITING_PAYMENT': 'AWAITING PAYMENT',
};

export default bookings;
